import { DropzoneOptions } from 'react-dropzone'

import { DEFAULT_MAX_FILES, DEFAULT_MAX_FILE_SIZE_BYTES, IMAGE_FILE_TYPES, PDF_FILE_TYPES } from '../../constants'

export const defaultDropzoneConfig: Partial<DropzoneOptions> = {
  maxSize: DEFAULT_MAX_FILE_SIZE_BYTES,
  maxFiles: DEFAULT_MAX_FILES,
  accept: {
    'image/*': IMAGE_FILE_TYPES,
    'application/pdf': PDF_FILE_TYPES,
  },
  multiple: true,
  noDragEventsBubbling: true,
  noClick: true,
}
